import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { defaultProductMargin } from '../../library/constants/defaults.js';
import { formatter, parser } from './Currency.jsx';

const Percent = ({ value = null, onChange, ...otherProps }) => {
    return (
        <InputNumber
            defaultValue={defaultProductMargin}
            value={value}
            controls={false}
            onChange={onChange}
            step="0.01"
            precision={2}
            decimalSeparator=","
            formatter={(v, info) => formatter(v, 'EUR', 2, info)}
            parser={(v) => parser(v, 'EUR')}
            className="inputfield--percentage"
            id="percent-field"
            min={-10000}
            max={10000}
            onFocus={event => event.target.select()}
            {...otherProps}
        />
    )
}

Percent.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
}

export default Percent;